import { Box, Button, Modal, Stack, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { useQueryClient } from 'react-query';
import { updateActPoNumServ } from '../../../services/source-service';



function PoNumMdl({ modalOpen, handleModalClose, poData }) {
    const theme = useTheme();
    const { setLoadingScreen } = useAuthContext();
    const [formErrors, setFormErrors] = useState({});
    const queryClient = useQueryClient();

    async function handleSubmit(e) {
        e.preventDefault();

        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;
        setLoadingScreen(true);
        try {
            const payload = {
                poIdStrg: poData?.poIdStrg,
                actPoNum: inputObject?.actPoNum
            }
            const { message } = await updateActPoNumServ(payload);
            notify("success", message);
            handleModalClose();
            queryClient.invalidateQueries();
        } catch (err) {
            console.log(err);
            customAlert(err);
        }
        setLoadingScreen(false);
    }

    function validate(values) {
        const errors = {};
        // if (!values.actPoNum)
        //     errors.actPoNum = "actPoNum is required!";
        return errors;
    };

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {poData ? <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={2.5}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>Update PO Number</Typography>
                    </Stack>
                    <Stack gap={2} alignItems="center">
                        <LabelTxtFieldInfo name="actPoNum" title="PO Number" width={"100%"} borderRadius={1} defaultValue={poData?.actPoNum} />
                        <Stack justifyContent={"flex-end"} direction={"row"} sx={{ mt: 2 }} width={400} gap={2}>
                            <Button variant="text" sx={{ color: theme.palette.custom.btn, height: 30 }} onClick={handleModalClose}> CANCEL</Button>
                            <Button variant="contained" type='submit' sx={{ color: "white", bgcolor: theme.palette.custom.btn, height: 30 }}> SAVE</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form> : <Typography component={'h1'}>Something went wrong</Typography>}
        </Modal>
    )
}

export default PoNumMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2,
};